




































































































































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import Utils from '@root/utils/common';
import * as _ from 'lodash';
import {
  baseSentryList,
  disableOrEnable,
  bindChannel,
  findChannelByAreaId,
  findAreaByParkId,
  findChannelByParkId,
  checkedChannels,
  baseSentryDelete
} from '@/api/parking-lot-management/index';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import { GANG_CREATE, GANG_EDIT } from '../router-names';
export interface IForm {
  parkName: string; //name
  channelIds: []; //通道
  areaIds: []; //
}
@Component({
  name: 'GangStop',
  components: { ParkingLotSearch }
})

// @Component
export default class GangStop extends Mixins(TableMixin, TableWidthMixin) {
  // 邦定通道
  bindingVisible: Boolean = false;
  bindingForm: any = null;
  // @ts-ignore
  gangStopTypeOptions: IOption[] = _.concat(
    [{ label: '全部', value: '' }],
    Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.sentry_type)
  ); // 岗亭类型选项
  sentryType = ''; // 岗亭类型选中值,
  sentryName = '';
  tableData: any[] = []; // 表数据
  tableLoading = false;
  parkIds = [];
  areaList = []; //区域列表
  channelList = []; //通道列表
  parkId = '';
  id = '';
  spinning = false;
  sentryId: string = '';
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '岗亭编号',
        dataIndex: 'id',
        width: 250,
        scopedSlots: { customRender: 'text-ellipse-22' }
      },
      {
        title: '岗亭名称',
        dataIndex: 'name',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '岗亭类型',
        dataIndex: 'typeDesc',
        width: 140,
        customRender: (text: any) => text || '--'
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '岗亭版本',
        dataIndex: 'sentryVersion',
        width: 140,
        scopedSlots: { customRender: 'text-ellipse-12' }
      },
      // {
      //   title: '中央服务地址',
      //   dataIndex: 'centerAddress',
      //   width: 170,
      //   customRender: (text: any) => text || '--',
      // },
      {
        title: '绑定通道',
        dataIndex: 'channelName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      // {
      //   title: '使用状态',
      //   dataIndex: 'enabled',
      //   width: 140,
      //   scopedSlots: { customRender: 'enabled' },
      // },
      {
        title: '更新时间',
        dataIndex: 'createTime',
        width: 200
      },
      {
        title: '当班人',
        dataIndex: 'dutyMan',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 200,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  /**
   * 新增跳转
   */
  toCreate(name: string, id: string) {
    if (name == 'add') {
      this.$router.push({
        name: GANG_CREATE
      });
    } else {
      this.$router.push({
        name: GANG_EDIT,
        params: {
          id
        }
      });
    }
  }
  bindingVisibleCancel() {
    this.bindingVisible = false;
  }
  //根据车场ID 获取区域列表
  async getAreaList(parkId: any) {
    try {
      const { data } = await findAreaByParkId({ parkId: parkId });
      this.areaList = data ? data : [];
    } catch (e) {
      this.spinning = false;
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  //根据车场ID 获取通道列表
  async getChannelListByPark(parkId: any) {
    try {
      const { data } = await findChannelByParkId({ parkId: parkId, sentryId: this.id });
      this.channelList = data ? data : [];
    } catch (e) {
      this.spinning = false;
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  //根据区域ID 获取通道列表
  async getChannelList(areaId: any) {
    if (areaId.length > 0) {
      try {
        const { data } = await findChannelByAreaId({ areaId: areaId.join(','), sentryId: this.id });
        this.channelList = data ? data : [];
      } catch (e) {
        this.spinning = false;
        this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
      }
    } else {
      this.channelList = [];
    }
    this.bindingForm.setFieldsValue({
      channelIds: []
    });
  }
  //根据岗亭id,返回已选择的通道IDs
  async getCheckedChannel(id: any) {
    try {
      const { data } = await checkedChannels({ id: id });
      if (data && data.length > 0) {
        const channels = data.map((element: any) => element.channelId);
        const areas = data.map((element: any) => element.areaId);
        this.bindingForm.setFieldsValue({
          channelIds: _.uniq(channels),
          areaIds: _.uniq(areas)
        });
      } else {
        this.bindingForm.setFieldsValue({
          channelIds: [],
          areaIds: []
        });
      }
    } catch (e) {
      this.spinning = false;
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  //更改区域
  changeArea(value: any) {
    this.getChannelList(value);
  }
  //绑定通道
  async bindChannel(row: any) {
    this.parkId = row.parkId;
    this.id = row.id;
    this.bindingVisible = true;
    this.spinning = true;
    const { parkId, parkName, id, channelName } = row;
    this.bindingForm = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          parkName: this.$form.createFormField({
            value: parkName
          })
        };
      }
    });
    await this.getAreaList(row.parkId);
    await this.getChannelListByPark(row.parkId);
    if (channelName) {
      await this.getCheckedChannel(row.id);
    }
    this.spinning = false;
  }
  // 提交监听处理
  async handleSubmit(e: any) {
    // console.log(e)
    e.stopPropagation();
    e.preventDefault();
    this.bindingForm.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.spinning = true;
        try {
          let json = {
            id: this.id,
            parkId: this.parkId,
            channelIds: values.channelIds.toString()
          };
          const res = await bindChannel(json);
          this.$message.success('绑定成功');
          this.bindingForm.resetFields();
          this.bindingVisibleCancel();
          this.fetchTableData();
        } catch (e) {
          this.$message.error((e && e.msg) || '绑定失败');
        } finally {
          this.spinning = false;
        }
      }
    });
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }
  // 渲染列表请求
  async fetchTableData(isRefresh?: any) {
    if (isRefresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { status, code, msg, data } = await baseSentryList({
        parkId: this.parkIds.join(','),
        sentryName: this.sentryName,
        currPage: this.current,
        pageSize: this.pageSize,
        sentryType: this.sentryType
      });
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      this.tableData = datas;
      this.total = totalNum - 0;
      this.current = currPage - 0;
      this.pageSize = pageSize - 0;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  /**
   * 查询条件清空
   */
  clear({ defaultParkIdList }) {
    // TODO
    this.sentryType = '';
    this.sentryName = '';
    this.parkIds = defaultParkIdList;
    this.searchTable();
  }
  // 禁用启用事件
  async isforbiddenChange(row: any) {
    try {
      const { status, msg, code, data } = await disableOrEnable({
        id: row.id,
        status: row.enabled === '01' ? '00' : '01'
      });
      // console.log(res)
      if (status === '9999') {
        this.$message.success(`${row.enabled === '01' ? '禁用' : '启用'}成功`);
        this.fetchTableData();
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      this.$message.error((e && e.msg) || `${row.enabled === '01' ? '禁用' : '启用'}失败`);
    }
  }
  //删除岗亭
  async deleteItem(row: any) {
    //baseSentryDelete
    try {
      const { status, msg } = await baseSentryDelete({
        id: row.id
      });
      // console.log(res)
      if (status === '9999') {
        this.$message.success('删除成功');
        this.fetchTableData();
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '删除失败');
    }
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  //
  cancel() {}
  created() {
    this.fetchTableData();
  }
  getCharCount(str) {
    if (!str) return 0;
    str = str.split(',');
    return str.length;
  }
  activated() {
    // if (this.$route.params.parkId) {
    //   this.parkIds = []
    //   this.parkIds.push(this.$route.params.parkId)
    //   this.fetchTableData()
    // }
  }
}
